export default __webpack_public_path__ + "static/userJoin4-f3f59118f6a9761f6d522f9092731a5c.jpg";